<template>
  <div>
    <JadeBox hasPadding>
      <div class="contact-owner__img--container">
        <img :src="require(`@/assets/kyc/step_0.svg`).default" />
      </div>
      <div class="contact-owner__text--container">
        <jade-text
          weight="bold"
          variant="heading-small"
        >
          {{ $t('title') }}
        </jade-text>
        <jade-text variant="text-medium">
          {{ $t('subtitle') }}
        </jade-text>
      </div>

      <jade-button
        size="medium"
        class="contact-owner__button--container"
        @click="redirectToCompany"
      >
        {{ $t('button') }}
      </jade-button>
    </JadeBox>
  </div>
</template>
<script>
import JadeBox from '@jade/JadeBox/index.vue'
import JadeText from '@jade/JadeText/index.vue'
import JadeButton from '@jade/JadeButton/index.vue'
import { EXTERNAL_ENDPOINTS } from '@/external-endpoints/index.js'

export default {
  name: 'ContactOwner',
  components: {
    JadeBox,
    JadeText,
    JadeButton
  },
  props: {
    merchantId: String
  },
  methods: {
    redirectToCompany () {
      return window.location.assign(
        EXTERNAL_ENDPOINTS.COMPANY.url(this.merchantId)
      )
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.contact-owner__img--container {
  display: flex;
  justify-content: center;
  padding-bottom: var(--global-space-300, 24px);
}
.contact-owner__text--container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--global-space-200, 16px);
  padding-bottom: var(--global-space-300, 24px);
}

.contact-owner__button--container {
  width: 100%;
}
</style>

<i18n>
  {
    "pt-BR": {
      "title": "Fale com quem é o proprietário dessa conta",
      "subtitle": "A validação precisa ser feita na conta de um perfil de proprietário.",
      "button": "Voltar para Empresas"
    },
    "en-US": {
      "title": "Speak to whoever owns this account",
      "subtitle": "Validation needs to be done on an owner profile account.",
      "button": "Back to Companies"
    }
  }
  </i18n>
